module.exports = __webpack_public_path__ + "static/media/coming-soon.28d6c3f7.svg";